import { initializeApp } from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/database';

const firebaseConfig = {
	apiKey: "AIzaSyCKGHTQeW6VWRMOprV4N-4ycMU416c47Es",
	authDomain: "andy-site-1b9e7.firebaseapp.com",
	projectId: "andy-site-1b9e7",
	storageBucket: "andy-site-1b9e7.appspot.com",
	messagingSenderId: "692996169174",
	appId: "1:692996169174:web:146af46f55488cbb99d877",
	measurementId: "G-85E3QH94WP",
};

const firebase = initializeApp(firebaseConfig);

export default firebase;